import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { ISetCamera } from "../../../models/interactions/SetCamera";
import CameraPickingBar from "./CameraPickingBar";

/** Set Camera's home in the viewport: the camera picking bar. */
export default function SetCameraPreview() {
  const setCam = useSelector(selectSelectedElement) as ISetCamera;
  return <CameraPickingBar title="Set Camera" setCamera={setCam} />;
}
